import React from 'react'
import Image from 'next/image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowSquareRight } from '@fortawesome/pro-light-svg-icons/faArrowSquareRight'
import { CityData } from '../CityPage'
import { pipe, take } from 'ramda'
import { mapIndexed } from '../../util/util'
import Link from 'next/link'
import { paramCase } from 'param-case'
import { Container } from '../Container'
import { ViewAllCitiesButton } from '../Button'
import { useQueryParam } from '../../hooks/useQueryParam'

import unitedState from '../../../public/img/united-states.svg'

export const OtherCitiesSection: React.FC<{ mainCities: CityData[] }> = ({ mainCities }) => {
  const query = useQueryParam()
  return (
    <section>
      <Container style={{ maxWidth: 800 }}>
        <div className="text-center pb-3">
          <h2>Need Brake Services In Another City?</h2>
          <Image className={'w-full mx-auto'} alt="NuBrakes Other Cities Header" src={unitedState} />
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          {
            pipe(
              take(12),
              mapIndexed((city: CityData, rowIndex: number) => (
                <div className="flex flex-row md:justify-end" key={rowIndex}>
                  <Link
                    as={{
                      pathname: `/cities/${paramCase(city.cityName!)}-brake-repair/`,
                      query,
                    }}
                    href={`/cities/[slug]`}
                  >
                    <a style={{ color: '#a6adb4' }}>
                      <span className="pr-3">{`${city.cityName}, ${city.stateAbbreviation}`} Brake Repair</span>
                      <FontAwesomeIcon size={'lg'} icon={faArrowSquareRight} color={'#a6adb4'} />
                    </a>
                  </Link>
                </div>
              ))
            )(mainCities) as any
          }
        </div>
        <div className="text-center pt-6">
          <Link href={{ pathname: '/cities/', query }} passHref={true}>
            <a>
              <ViewAllCitiesButton>VIEW ALL CITIES</ViewAllCitiesButton>
            </a>
          </Link>
        </div>
      </Container>
    </section>
  )
}
